import PinGreenIcon from './component'

export default PinGreenIcon
